import React, { useState, Fragment, useCallback } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import VehicleInfo from 'site-modules/shared/components/vin-decoder/vehicle-info/vehicle-info';
import { VinInputForm } from 'site-modules/shared/components/vin-decoder/vin-input-form/vin-input-form';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';

import './vin-decoder-content.scss';

export const VinDecoderContent = ({ children = '', className = '', id = undefined }) => {
  const [vin, setVin] = useState(null);
  const [squishVin, setSquishVin] = useState(null);

  const handleVinSubmit = useCallback(({ vin: fullVin, squishVin: submittedSquishVin }) => {
    setVin(fullVin);
    setSquishVin(submittedSquishVin);
  }, []);

  return (
    <div>
      <ContentFragment classes={classnames('vin-decoder-content', className)} id={id}>
        {children}
      </ContentFragment>
      <Fragment>
        <VinInputForm onVinSubmit={handleVinSubmit} />
      </Fragment>
      <Fragment>{squishVin && <VehicleInfo vin={vin} squishVin={squishVin} />}</Fragment>
    </div>
  );
};

VinDecoderContent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
};
